<template>
  <hm-content title="新增活动">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="product-ruleForm"
    >
      <el-form-item label="活动名称：" prop="actName">
        <el-input
          style="width: 400px"
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.actName"
          placeholder="请输入活动名称"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动日期：" prop="activityDate">
        <el-date-picker
          v-model="ruleForm.activityDate"
          type="daterange"
          align="right"
          :picker-options="pickerOptions"
          start-placeholder="活动开始时间"
          end-placeholder="活动结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="报名时间：" prop="applyDate">
        <el-date-picker
          v-model="ruleForm.applyDate"
          type="datetimerange"
          align="right"
          :picker-options="pickerOptions"
          start-placeholder="报名开始时间"
          end-placeholder="报名结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动地点：" prop="actAddress">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.actAddress"
          placeholder="请输入活动地点"
        ></el-input>
      </el-form-item>
      <el-form-item label="适合人群：" prop="suitPerson">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.suitPerson"
          placeholder="请输入适合项目的人群/年龄"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动人数上限：" prop="actMemberUpperLimit">
        <el-input
          size="small"
          clearable
          type="number"
          @mousewheel.prevent.native
          class="mr10 ipt"
          v-model.number="ruleForm.actMemberUpperLimit"
          placeholder="请输入活动人数上限，用于手机端显示"
        ></el-input>
      </el-form-item>
      <el-form-item label="已报名人数：" prop="registeredAmount">
        <el-input
          size="small"
          type="number"
          clearable
          @mousewheel.prevent.native
          class="mr10 ipt"
          v-model.number="ruleForm.registeredAmount"
          placeholder="请输入已报名人数，用于手机端显示"
        ></el-input>
        <span v-if="ruleForm.registeredAmount && ruleForm.actMemberUpperLimit">
          /{{ ruleForm.actMemberUpperLimit + ruleForm.registeredAmount }}
        </span>
      </el-form-item>
      <el-form-item label="活动地点：" prop="actSite">
        <div class="location-list">
          <div
            class="location-item"
            v-for="(item, index) in ruleForm.round"
            :key="index"
          >
            <div class="event-adress">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="item.actSite"
                placeholder="请输入活动地点"
              ></el-input>
              <el-button
                type="primary"
                v-if="index === 0"
                @click="addLocationItem"
                size="mini"
                icon="hmicon icon-hao"
                circle
              ></el-button>
              <el-button
                type="warning"
                v-else
                @click="deleteCurrentLocation(index)"
                size="mini"
                icon="hmicon icon-jianhao"
                circle
              ></el-button>
            </div>
            <div class="event-details-table">
              <div class="table-header flex">
                <div class="flex-1 title">活动场次</div>
                <div class="flex-1 title">场次人数上限</div>
                <div class="flex-2 title actCostMoney">
                  活动费用
                  <span>(积分和金额都为0表示免费)</span>
                </div>
              </div>
              <div class="table-body">
                <div
                  class="activity-item flex"
                  v-for="(v, i) in item.subscribeRound"
                  :key="i"
                >
                  <div class="flex-1 ipt-wrapper flex flex-center">
                    <el-input
                      clearable
                      size="small"
                      v-model="v.actRound"
                      placeholder="活动场次"
                    />
                  </div>
                  <div class="flex-1 ipt-wrapper flex flex-center">
                    <el-input
                      type="number"
                      clearable
                      size="small"
                      placeholder="场次人数上限"
                      @mousewheel.prevent.native
                      v-model.number="v.onceActMemberUpperLimit"
                    />
                  </div>
                  <div class="flex-2 ipt-wrapper flex flex-between">
                    <div class="flex flex-1">
                      <el-input
                        type="number"
                        placeholder="报名金额"
                        @mousewheel.prevent.native
                        clearable
                        class="mr10"
                        size="small"
                        v-model="v.actCostMoney"
                      />
                      <el-input
                        type="number"
                        placeholder="建议报名积分大于100"
                        @input="filterInteger(v, 'actCostIntegral')"
                        @mousewheel.prevent.native
                        clearable
                        class="mr10"
                        size="small"
                        v-model.number="v.actCostIntegral"
                      />
                    </div>
                    <div>
                      <el-button
                        type="primary"
                        @click="addActivityItem(index)"
                        size="mini"
                        v-if="i === 0"
                        icon="hmicon icon-hao"
                        circle
                      ></el-button>
                      <el-button
                        type="warning"
                        v-else
                        @click="deleteCurrentActivity(index, i)"
                        size="mini"
                        icon="hmicon icon-jianhao"
                        circle
                      ></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="主图：" prop="mainImgUrl">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="show"
          noCircle
          noSquare
          :width="345"
          :height="180"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'mall' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!listHeaderImgUrl"
          @click="toggleShow"
          >上传</el-button
        >
        <span class="form-tip">（主图仅可设置一张，图片尺寸建议345x180）</span>
        <div class="priview" v-if="listHeaderImgUrl">
          <img :src="listHeaderImgUrl" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="轮播组图：" prop="listDetail">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showDetail"
          noCircle
          noSquare
          :width="345"
          :height="180"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'mall' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="uploadedDetailList.length < 6"
          @click="toggleShowDetail"
          >上传</el-button
        >
        <span class="form-tip"
          >（列表详情图可设置6张，图片尺寸建议345x180）</span
        >
        <ul class="flex flex-wrap">
          <li
            class="priview mr10"
            v-show="v"
            v-for="(v, i) in uploadedDetailList"
            :key="i"
          >
            <img :src="v" alt="列表详情图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="setFirst(i)"
                >设为第一张图</el-button
              >
              <el-button type="text" @click="handleRemoveListDetail(i)"
                >删除</el-button
              >
            </div>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="图文详情：" prop="actDesc">
        <hm-rich-editor v-model="ruleForm.actDesc" />
      </el-form-item>
      <el-form-item label="活动状态：">
        <el-switch
          v-model="ruleForm.actStatus"
          active-color="#2d8"
          inactive-color="#ff4949"
          active-text="开启"
          inactive-text="关闭"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>

<script>
import moment from "moment";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { getLoginUser } from "@/utils/auth";

export default {
  components: { myUpload, HmRichEditor },
  data() {
    const patternListHeader = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;
      this.ruleForm.round.map(o => {
        if (!o.actSite) {
          haveEmptyCondition = true;
        }
        o.subscribeRound.map(v => {
          for (let key in v) {
            if (v[key] === "") {
              haveEmptyCondition = true;
            }
          }
        });
      });
      if (haveEmptyCondition) {
        return callback(new Error("请填写完所有项"));
      }
      callback();
    }.bind(this);
    const patternRegisteredAmountFunc = function(rule, val, callback) {
      if (val > +this.ruleForm.actMemberUpperLimit) {
        return callback(new Error("已报名人数不能大于活动人数上限"));
      }
      callback();
    }.bind(this);
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      showDetail: false,
      show: false,
      inputVisible: false,
      isMininum: true,
      applyCount: 0,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      chargeType: "",
      ruleForm: {
        adImg: "",
        actName: "",
        actStatus: 1,
        round: [
          {
            actSite: "",
            subscribeRound: [
              {
                actRound: "",
                onceActMemberUpperLimit: "",
                actCostIntegral: "",
                actCostMoney: ""
              }
            ]
          }
        ],
        activityDate: [],
        applyDate: [],
        actAddress: "",
        suitPerson: "",
        actDesc: "",
        registeredAmount: "",
        actMemberUpperLimit: ""
      },
      rules: {
        actCostMoney: {
          required: true,
          message: "请输入活动总金额",
          trigger: "blur"
        },
        actName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 2, message: "长度不能小于2个字符", trigger: "blur" }
        ],
        actAddress: [
          { required: true, message: "请输入活动地点", trigger: "blur" }
        ],
        activityDate: [
          { required: true, message: "请输入活动时间", trigger: "change" }
        ],
        suitPerson: [
          { required: true, message: "请输入适合人群/年龄", trigger: "blur" }
        ],
        applyDate: [
          { required: true, message: "请输入报名时间", trigger: "change" }
        ],
        actDesc: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        actSite: [
          { required: true, validator: patternLocation, trigger: "blur" }
        ],
        registeredAmount: [
          { required: true, message: "请输入报名人数", trigger: "blur" },
          {
            validator: patternRegisteredAmountFunc,
            trigger: "blur"
          }
        ],
        actMemberUpperLimit: [
          { required: true, message: "请输入活动人数上限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入大于等于0的正整数"));
              }
            },
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    filterRuleFormNegativeNumber(prop) {
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(/-/g, "")
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
    },
    filterRuleFormInregral(prop) {
      this.ruleForm[prop] = String(this.ruleForm[prop]).replace(/-|\.|/g, "");
    },
    filterInteger(v, prop) {
      if (v[prop]) {
        v[prop] = +String(v[prop])
          .replace(/-/g, "")
          .replace(/\./g, "");
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    addLocationItem() {
      this.ruleForm.round.push({
        actAddress: "",
        subscribeRound: [
          {
            actRound: "",
            onceActMemberUpperLimit: "",
            actCostIntegral: "",
            actCostMoney: ""
          }
        ]
      });
    },
    deleteCurrentLocation(index) {
      this.ruleForm.round.splice(index, 1);
    },
    addActivityItem(index) {
      this.ruleForm.round[index].subscribeRound.push({
        actRound: "",
        onceActMemberUpperLimit: "",
        actCostIntegral: "",
        actCostMoney: ""
      });
    },
    deleteCurrentActivity(index, i) {
      this.ruleForm.round[index].subscribeRound.splice(i, 1);
    },
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    formatValidDate(type) {
      if (type === 0) {
        this.validDate = "不限时间";
      } else if (type === 1) {
        this.validDate = `购买后${this.ruleForm.validSpaceDay}天后生效，有效期${
          this.ruleForm.validDay
        }天`;
      } else if (type === 2) {
        const startDate = this.ruleForm.dateAndTime[0]
          ? moment(this.ruleForm.dateAndTime[0]).format("YYYY-MM-DD")
          : "";
        const endDate = this.ruleForm.dateAndTime[1]
          ? moment(this.ruleForm.dateAndTime[1]).format("YYYY-MM-DD")
          : "";
        this.validDate = `${startDate}-${endDate}`;
      }
    },
    minimum() {
      this.isMininum = !this.isMininum;
    },
    getChargeType(id) {
      this.chargeType = id
        ? this.serviceList.list.find(v => v.id === id).chargeType
        : "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.ruleForm.productTags.splice(
        this.ruleForm.productTags.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.productTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params.actCostMoney = +params.actCostMoney;
          params.actCostIntegral = +params.actCostIntegral;
          params = Object.assign(params, {
            detailImg: this.uploadedDetailList.join(","),
            mainImgUrl: this.listHeaderImgUrl,
            productTags: this.ruleForm.productTags,
            userId: getLoginUser().userId
          });
          this.$store.dispatch("addReservationActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.listHeaderImgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 345;
        let height = 180;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传345*180的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          v => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}

.event-details-table {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  .table-header {
    background: #f7f7f7;
    padding: 0 10px;
    .title {
      text-align: center;
    }
  }
  .activity-item {
    padding: 0 10px;
    .ipt-wrapper {
      box-sizing: border-box;
      .el-input {
        width: 80%;
      }
    }
  }
}

.location-item:not(:last-child) {
  margin-bottom: 20px;
}

.actCostMoney {
  padding-left: 20px;
  span {
    color: #999;
  }
}

.event-adress {
  margin-bottom: 10px;
}
</style>
